import { getPageTitle } from '@/navigation/nav-items';

/** Human page name for a saved-view pathname (from the nav, not a URL slug). */
export function savedFilterPageLabel(pathname: string): string {
  return getPageTitle(pathname) || pathname;
}
